import type { Question as QuestionType } from '@api/instant_survey/types';

import { createQuestionKey } from '../../../pages/CreateInstantSurvey/utilities/helpers';
import type { PipingQuestionsMap } from './types';

export const EMPTY_PIPING_QUESTIONS_MAP: PipingQuestionsMap = {
  childrenByParent: {},
  parentsByChild: {},
};

export const noop = () => {};

export const getQuestionKey = (question: QuestionType, index: number) => {
  const questionKey = createQuestionKey(question);

  return `question-${questionKey || index}`;
};
